/**
 * Settings API Service
 * Handles all settings-related API calls
 */

import { getUID } from '@/utils';
import axios from 'axios';

const API_BASE_URL = 'https://api.jackopot.com';

/**
 * Fetch 2FA status
 */
export const fetch2FAStatus = async () => {
  const uid = getUID();
  const response = await axios.get(`${API_BASE_URL}/2fa/status/${uid}`);
  return response.data;
};

/**
 * Initiate 2FA setup
 */
export const initiate2FASetup = async () => {
  const uid = getUID();
  const response = await axios.post(`${API_BASE_URL}/2fa/enable`, {
    uid
  });
  return response.data;
};

/**
 * Verify 2FA setup
 */
export const verify2FA = async (token) => {
  const uid = getUID();
  const response = await axios.post(`${API_BASE_URL}/2fa/setup-verify`, {
    uid,
    token
  });
  return response.data;
};

/**
 * Disable 2FA
 */
export const disable2FA = async (token) => {
  const uid = getUID();
  const response = await axios.post(`${API_BASE_URL}/2fa/disable`, {
    uid,
    token
  });
  return response.data;
};

/**
 * Change password
 */
export const changePassword = async (oldPassword, newPassword) => {
  const uid = getUID();
  const response = await axios.post(`${API_BASE_URL}/user/change-password`, {
    uid,
    oldPassword,
    newPassword
  });
  return response.data;
};

/**
 * Fetch active sessions
 */
export const fetchActiveSessions = async () => {
  const uid = getUID();
  const response = await axios.get(`${API_BASE_URL}/sessions/${uid}`);
  return response.data;
};

/**
 * Terminate session
 */
export const terminateSession = async (sessionId) => {
  const uid = getUID();
  const response = await axios.delete(`${API_BASE_URL}/sessions/${uid}/${sessionId}`);
  return response.data;
};

/**
 * Fetch KYC status
 */
export const fetchKYCStatus = async () => {
  const uid = getUID();
  const response = await axios.get(`${API_BASE_URL}/kyc/status/${uid}`);
  return response.data;
};

/**
 * Submit KYC verification
 */
export const submitKYC = async (formData) => {
  const uid = getUID();
  const kycFormData = new FormData();
  
  kycFormData.append('userId', uid?.toString());
  kycFormData.append('firstName', formData.firstName?.trim());
  kycFormData.append('lastName', formData.lastName?.trim());
  kycFormData.append('gender', formData.gender?.toLowerCase());
  kycFormData.append('dob', formData.dateOfBirth);
  kycFormData.append('address', formData.address?.trim());
  kycFormData.append('city', formData.city?.trim());
  kycFormData.append('country', formData.country?.trim());
  kycFormData.append('documentType', formData.documentType?.toLowerCase());

  if (formData.documentType === 'idCard') {
    if (formData.idCardFront) {
      kycFormData.append('documentFront', formData.idCardFront);
    }
    if (formData.idCardBack) {
      kycFormData.append('documentBack', formData.idCardBack);
    }
  } else if (formData.documentType === 'passport' && formData.passport) {
    kycFormData.append('documentFront', formData.passport);
  }

  const response = await axios.post(`${API_BASE_URL}/kyc/submit`, kycFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
